'use client';

import { useRouter } from 'next/navigation';
import { setCookie } from 'cookies-next';
import { useEffect, useTransition } from 'react';

export default function Page() {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    setCookie('user-type', 'agent');
    startTransition(() => router.push('/'));
    startTransition(() => router.refresh());
  }, []);

  if (isPending) {
    return;
  }

  return <></>;
}
